import { postRequest } from '@/core';
import { edi } from '@/requests';

export default async function(searchFilter) {
	let url = edi.getOutboundTransmissionsPath();
	let response = await postRequest(url, {}, searchFilter);
	return response;
}